import { SectionShell, Note } from "@/components/dash/primitives";
import { StatCard } from "@/components/dash/StatCard";

export default function Summary({ data, num, title }) {
  return (
    <SectionShell id="summary" num={num} title={title}>
      <p className="font-num text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">{data.headline}</p>
      <p className="text-lg text-slate-700 leading-relaxed max-w-4xl mb-10">{data.lede}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {data.stats.map((s, i) => (
          <StatCard key={i} stat={s} testid={`summary-stat-${i}`} />
        ))}
      </div>
      <Note accent>{data.note}</Note>
    </SectionShell>
  );
}
